import { Helper } from "../util/helper.js";
import { InGridToolBarButton } from "./editableGrid/editableGrid.js";
import ToolBarContextMenu, { ToolBarContextMenuOpenParams } from "./mobile/toolBarContextMenu.js";
import ToolBarFloatingButtons from "./mobile/toolBarFloatingButtons.js";
import React from "react";
export enum ToolBarStandardButtonType {
    NEW = 1, EDIT, DELETE, RELOAD
}

export enum ToolBarInGridButtonType {
    NEW = 1, EDIT, DELETE, CUSTOM
}

export enum ToolBarStandardIconClass {
    NEW = "k-i-plus",
    EDIT = "k-i-pencil",
    DELETE = "k-i-close",
    RELOAD = "k-i-refresh"
}

export class ToolBar extends React.Component<ToolBarProps, any>{

    private getButtons = () => {
        var buttons = [];
        let index = 1;

        if (Helper.hasValue(this.props.standardButtons) && this.props.standardButtons.length > 0) {
            for (let button of this.props.standardButtons) {

                if ((this.props.contextMenu?.use && (button.type == ToolBarStandardButtonType.EDIT || button.type == ToolBarStandardButtonType.DELETE))
                    || (this.props.useFloatingButtons && (button.type == ToolBarStandardButtonType.NEW || button.type == ToolBarStandardButtonType.RELOAD)))
                    continue;

                let iconClass;
                let disabled = !button.enabled;
                if (button.type == ToolBarStandardButtonType.NEW) {
                    iconClass = "k-i-plus";
                }
                else if (button.type == ToolBarStandardButtonType.EDIT) {
                    iconClass = "k-i-pencil";
                }
                else if (button.type == ToolBarStandardButtonType.DELETE) {
                    iconClass = "k-i-close";
                }
                else if (button.type == ToolBarStandardButtonType.RELOAD) {
                    iconClass = "k-i-refresh";
                }
                else {
                    throw new Error("Unsupported GridPropsStandardButtonType!");
                }
                let style: React.CSSProperties = (disabled) ? { pointerEvents: 'none' } : {};
                buttons.push(<button style={style} type="button" key={index++} disabled={disabled} onClick={() => !disabled ? this.props.handleStandardButtonClick(button.type) : null}
                    className="k-button k-grid"><span className={"k-icon " + iconClass}></span>{button.caption}</button>)
            }
        }

        if (Helper.hasValue(this.props.customButtons) && this.props.customButtons.length > 0) {
            for (let button of this.props.customButtons) {

                if ((this.props.contextMenu?.use && (button.useContextMenu ?? false))
                    || (this.props.useFloatingButtons && !(button.useContextMenu ?? false)))
                    continue;

                let buttonStyle: React.CSSProperties = {};
                if (button.width)
                    buttonStyle = { width: button.width };

                let disabled = !button.enabled;
                if (disabled)
                    buttonStyle.pointerEvents = 'none';
                //http://docs.telerik.com/kendo-ui/backwards-compatibility/2017-backward-compatibility <--- verfügbare Incons
                buttons.push(<button type="button" key={index++} disabled={disabled} onClick={() => !disabled ? this.props.handleCustomButtonClick(button.id) : null}
                    className="k-button k-grid" style={buttonStyle} ><span className={button.iconClass?.startsWith("k-") ? "k-icon " + button.iconClass : button.iconClass}></span>{button.caption}</button >)
            }
        }

        return buttons;
    }

    private getButtonsInGrid = () => {
        let buttons: InGridToolBarButton[] = [];
        if (Array.isArray(this.props.standardButtons)) {
            for (let standardButton of this.props.standardButtons) {
                buttons.push({
                    type: standardButton.type,
                    id: standardButton.type.toString(),
                    caption: standardButton.caption,
                    iconClass: standardButton.type == ToolBarStandardButtonType.NEW ? "k-i-plus" : (standardButton.type == ToolBarStandardButtonType.EDIT ? "k-i-pencil" : (standardButton.type == ToolBarStandardButtonType.DELETE ? "k-i-close" : "k-i-refresh")),
                    enabled: () => standardButton.enabled,
                    useContextMenu: standardButton.type == ToolBarStandardButtonType.EDIT || standardButton.type == ToolBarStandardButtonType.DELETE
                });
            }
        }

        if (Array.isArray(this.props.customButtons)) {
            for (let customButton of this.props.customButtons) {
                buttons.push({
                    type: ToolBarInGridButtonType.CUSTOM,
                    id: customButton.id,
                    caption: customButton.caption,
                    iconClass: customButton.iconClass,
                    enabled: () => customButton.enabled,
                    useContextMenu: customButton.useContextMenu,
                    width: customButton.width
                });
            }
        }

        return buttons;
    }

    private handleButtonClick = (btn: InGridToolBarButton) => {
        if (btn.type == ToolBarInGridButtonType.CUSTOM)
            this.props.handleCustomButtonClick(btn.id);
        else
            this.props.handleStandardButtonClick(btn.type);
    }

    render() {
        var buttons = this.getButtons();

        let floatingButtons = (this.props.useFloatingButtons ?? false)
            ? <ToolBarFloatingButtons buttons={this.getButtonsInGrid().filter(x => !x.useContextMenu)} onClick={this.handleButtonClick} />
            : null;
        let contextMenu = (this.props.contextMenu?.use ?? false)
            ? <ToolBarContextMenu
                target={this.props.contextMenu.target}
                filter={this.props.contextMenu.filter}
                visible={this.props.contextMenu.visible}
                open={(p) => {
                    if (this.props.contextMenu.open)
                        this.props.contextMenu.open(p);
                }}
                buttons={this.getButtonsInGrid().filter(x => x.useContextMenu)}
                handleButtonClick={this.handleButtonClick}
                ref={this.props.contextMenu.ref} />
            : null;

        return (<>
            <div className="innoToolBarWrapper" style={{ display: Helper.hasValue(this.props.standardButtons) || Helper.hasValue(this.props.customButtons) ? "" : "none" }}>
                {buttons}
            </div>
            {floatingButtons}
            {contextMenu}
        </>);
    }
}

interface ToolBarProps {
    standardButtons?: Array<ToolBarStandardButton>;
    customButtons?: Array<ToolBarCustomButton>;
    handleStandardButtonClick?(button: ToolBarStandardButtonType);
    handleCustomButtonClick?(buttonId: string);
    useFloatingButtons?: boolean;
    contextMenu?: {
        use: boolean,
        target: string,
        filter: string,
        visible: boolean,
        open?: (p: ToolBarContextMenuOpenParams) => void
        ref?: (ref: ToolBarContextMenu) => void
    }
}

export interface GridCustomToolBarButton extends ToolBarCustomButton {
    autoEnabledOnRecordSelected: boolean;
}

export interface ToolBarCustomButton {
    id: string;
    enabled: boolean;
    caption: string;
    iconClass: string;
    width?: string;
    useContextMenu?: boolean;
}

export interface ToolBarStandardButton {
    type: ToolBarStandardButtonType;
    enabled: boolean;
    caption: string;
}